import { Inject } from '@odinjs/odin';

import { Endpoint, FOUNDATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import { PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { NewUserConfirmationAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.NEW_USER_CONFIRMATION })
export default class NewUserConfirmationController extends BaseController {

  @Inject(Aliases.PANEL_LOADER)
  private loader: PanelAPI;
  @Inject(Aliases.PANEL_SUCCESS)
  private sucess: PanelAPI;
  @Inject(Aliases.PANEL_ERROR)
  private error: PanelAPI;

  @OnMount(Aliases.PANEL_NEW_USER_CONFIRMATION)
  onPanelMount(): void {
    const { hash } = this.historyService.getCurrentRouteParams();
    if (hash) {
      void HttpService.post(Endpoint.POST.NEW_USER_CONFIRMATION, { hash })
        .then(() => {
          this.loader.setVisible(false);
          this.sucess.setVisible(true);
        }).catch(() => {
          this.loader.setVisible(false);
          this.error.setVisible(true);
        });
    }
  }

  @OnClick(Aliases.BUTTON_ACCESS)
  onClickButton(): void {
    const currentRoute = this.historyService.getCurrentRoute();
    this.historyService.push(currentRoute.concat(FOUNDATION_ROUTES.LOGIN));
  }
}
